import { ReplicaType } from "types";
import Version1 from "./v1";
import Version2 from "./v2";
import replicaCategories from "assets/replicas/_categories";

const data: ReplicaType = {
  id: "daily-prophet-hp5-the-boy-who-lies",
  name: `The Daily Prophet\n'The Boy Who Lies?'`,
  nameFormatted: {
    primary: "The Daily Prophet",
    secondary: "'The Boy Who Lies?'",
  },
  origin: "Harry Potter and the Order of the Phoenix",

  category: replicaCategories.harryPotter,

  versions: [Version2, Version1],
};

export default data;
